import { getUserAccessPoliciesAsync } from '@chr/online-shared-microsite-core';
import { AccessPolicy } from '@chr/online-shared-microsite-core/types';

export const retrieveUserAccessPolicies = async (): Promise<AccessPolicy[]> => getUserAccessPoliciesAsync();
